import { AgError } from '@australiangreens/ag-error';

export class ListManagerFrontendError extends AgError {
  static errorName = 'ListManagerFrontendError';
}
